import Vue from 'vue'
import VueRouter from 'vue-router'

import { isEmpty } from 'lodash'
import qs from 'qs'
import CryptoJS from 'crypto-js'
/*
  router 처리 전 사전 처리 코드
   - return 값은 promise로 제공
*/
async function preProcessWithWas (param) {
  await window.vue.get(param.url, param)
    .then((response) => {
      window.vue.getInstance('lang').setLocaleRemote(param.locale, response.data)
      return Promise.resolve()
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

/*
  router 처리 전 사전 처리 코드
*/
function preProcessWithResource (param) {
  return window.vue.getInstance('lang').setLocaleResource(param.locale)
}

/*
  인스턴스 생성
*/
const createInstance = (rootRoutes, base, authenticatedCheckFunc, useCryptoQs = false) => {
  let router = ''

  let checkAuthorizeRouter = authenticatedCheckFunc || checkAuthorized

  // Router  전역 등록
  Vue.use(VueRouter)

  var routerObj = {
    mode: window.vue.config.router.mode,
    routes: rootRoutes,
    // scrollBehavior 2019-01-14
    // router로 화면 이동 후 기존 페이지 스크롤 위치를 기억하고 있어서 초기화 처리함
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return {x: 0, y: 0}
      }
    },
    parseQuery: function (q) {
      if (useCryptoQs) {
        var qObj = qs.parse(q)

        if (qObj.q) {
          try {
            var words = CryptoJS.enc.Base64.parse(qObj.q)
            var originalText = CryptoJS.enc.Utf8.stringify(words)
            return qs.parse(originalText)
          } catch (error) {
            console.log(error)
            return qObj
          }
        } else {
          return qObj
        }
      } else {
        return qs.parse(q)
      }
    },
    stringifyQuery: function (q) {
      var r = qs.stringify(q)
      if (useCryptoQs) {
        if (r) {
          try {
            if (r.indexOf('utm_source') > -1 || r.indexOf('utm_medium') > -1 || r.indexOf('utm_campaign') > -1 || r.indexOf('utm_content') > -1) {
              return r
            } else {
              var utf8r = CryptoJS.enc.Utf8.parse(r) // WordArray object
              var ciphertext = CryptoJS.enc.Base64.stringify(utf8r) // string: 'SGVsbG8gd29ybGQ='
              return '?q=' + ciphertext
            }
          } catch (error) {
            return r ? '?' + r : ''
          }
        } else {
          return ''
        }
      } else {
        return r ? '?' + r : ''
      }
    }
  }

  if (base !== undefined && !isEmpty(base)) {
    routerObj.base = base
  }

  router = new VueRouter(routerObj)

  router.onError((err) => {
    console.log('router on error: ', err)
  })

  router.onReady(() => {
    // console.log('router on Ready')
  })

  router.afterEach((to, from) => {
    // console.log('after each: ', to, from )
  })

  //
  //  전역 navigation guard 설정
  //  from에서 to로 이동전에 beforeEach 호출
  //    - to :이동할 url 객체
  //    - from : 현재 url 객체
  //    - next : to에서 지정한 url로 이동하기 위해 꼭 호출해야 하는 함수
  //    - to.meta 가 갖는 정보
  //        > authorized : 인증이 필요한 path 체크
  //        > lang : locale 변경이 필요한 path 체크
  //        > permission : 권한 여부 필요한 path 체크
  //
  router.beforeEach(function (to, from, next) {
    // console.log('before Each: ', to, from)
    // language control
    if (to.meta && to.meta.lang) { // 기본 lang 설정을 defaultLocale 활
      let localeMode = 'local'
      let locale = window.vue.config.app.defaultLocale
      let localeUrl = ''
      let params = {'locale': locale, 'url': localeUrl}
      let langObject = to.meta.lang
      params.locale = locale = langObject.locale
      params.url = localeUrl = langObject.url
      localeMode = langObject.mode

      if (localeMode === 'dynamic') {
        preProcessWithWas(params)
          .then((resolve) => checkAuthorizeRouter(to, from, next), (reject) => defaultRouter(next))
      } else {
        preProcessWithResource(params)
          .then((resolve) => checkAuthorizeRouter(to, from, next), (reject) => defaultRouter(next))
      }
    } else {
      checkAuthorizeRouter(to, from, next)
    }
  })

  return router
}

const defaultRouter = (next) => {
  next({ name: 'Login' })
}

const checkAuthorized = (to, from, next) => {
  if (to.meta && to.meta.authorized) {
    // authorized 필요 path에 대한 credential 검사
    var store = window.vue.getStore('root')
    if (store !== null && store.getters.getSession.authenticated) {
      next()
    } else {
      console.info('unauthorized to access')
      next({ name: 'Login' })
    }
  } else {
    next()
  }
}

var routerWrapper = {}
routerWrapper.createInstance = createInstance

export default routerWrapper



// WEBPACK FOOTER //
// ./src/_fdp/core/router/router.js